import {
  ICheckSessionEndResponse,
  IIparticipantsListUserResponse,
  IMessageResponse,
  IRejectResponse,
  IRequestListResponse,
  IRightsAllowResponse,
  IRightsRevokeResponse,
  ISessionDetailResponse,
  ISessionEndResponse,
  ISessionResponse,
} from "../@types/VideoCallTypes";
import { ApiName } from "../Constant/ApiName";
import { getRequest, postRequest, postRequestAuth } from "./NetWorkServices";

export const agoraInfoOTMService = async (requestData: { enc: string }) => {
  let endpoint = ApiName.decStringVideo;

  let { data }: { data: ISessionResponse } = await postRequestAuth(
    endpoint,
    requestData
  );
  return data;
};

export const agoraRequestListingOTMService = async (requestData: {
  session_id: string;
}) => {
  let endpoint =
    ApiName.requestListingVideo + "?sessionId=" + requestData.session_id;
  let { data }: { data: IRequestListResponse } = await getRequest(endpoint);
  return data;
};

export const agoraSessionDetailOTMService = async (requestData: {
  session_id: string;
}) => {
  let endpoint =
    ApiName.sessionDetailVideo + "?sessionId=" + requestData.session_id;
  let { data }: { data: ISessionDetailResponse } = await getRequest(endpoint);
  return data;
};

export const agoraSessionEndOTMService = async (requestData: {
  session_id: string;
}) => {
  let endpoint =
    ApiName.endSessionVideo + "?sessionId=" + requestData.session_id;
  let { data }: { data: ISessionEndResponse } = await postRequest(endpoint, {});
  return data;
};

export const agoraCheckSessionEndedOTMService = async (requestData: {
  session_id: string;
}) => {
  let endpoint =
    ApiName.sessionEndedvideo + "?sessionId=" + requestData.session_id;
  let { data }: { data: ICheckSessionEndResponse } = await getRequest(endpoint);
  return data;
};

export const rightsAllowOTMService = async (requestData: {
  session_id: number | null;
  userId: number | null;
}) => {
  let endpoint =
    ApiName.rightsAllowVideo +
    "?sessionId=" +
    requestData.session_id +
    "&userId=" +
    requestData.userId;
  let { data }: { data: IRightsAllowResponse } = await postRequest(
    endpoint,
    requestData
  );
  return data;
};

export const rightsRevokeOTMService = async (requestData: {
  session_id: number | null;
  userId: number | null;
}) => {
  let endpoint =
    ApiName.rightsRevokeVideo +
    "?sessionId=" +
    requestData.session_id +
    "&userId=" +
    requestData.userId;
  let { data }: { data: IRightsRevokeResponse } = await postRequest(
    endpoint,
    requestData
  );
  return data;
};

export const rejectRequestOTMService = async (requestData: {
  session_id: number | null;
  userId: number | null;
}) => {
  let endpoint =
    ApiName.rejectRequestvideo +
    "?sessionId=" +
    requestData.session_id +
    "&userId=" +
    requestData.userId;
  let { data }: { data: IRejectResponse } = await postRequest(
    endpoint,
    requestData
  );
  return data;
};

export const agoraLiveCommentsOTMService = async (requestData: {
  session_id: string;
}) => {
  let endpoint =
    ApiName.liveCommentsVideo + "?sessionId=" + requestData.session_id;
  let { data }: { data: IMessageResponse } = await getRequest(endpoint);
  return data;
};

////////////////Podcast Services//////////////////////

export const agoraInfoPodcastService = async (requestData: { enc: string }) => {
  let endpoint = ApiName.decStringPodcast;

  let { data }: { data: ISessionResponse } = await postRequestAuth(
    endpoint,
    requestData
  );
  return data;
};

export const agoraRequestListingPodcastService = async (requestData: {
  session_id: string;
}) => {
  let endpoint =
    ApiName.requestListingPodcast + "?sessionId=" + requestData.session_id;
  let { data }: { data: IRequestListResponse } = await getRequest(endpoint);
  return data;
};

export const agoraSessionDetailPodcastService = async (requestData: {
  session_id: string;
}) => {
  let endpoint =
    ApiName.sessionDetailPodcast + "?sessionId=" + requestData.session_id;
  let { data }: { data: ISessionDetailResponse } = await getRequest(endpoint);
  return data;
};

export const getParticipantsPodcastService = async (requestData: {
  session_id: string;
}) => {
  let endpoint =
    ApiName.getParticipants + "?sessionId=" + requestData.session_id;
  let { data }: { data: IIparticipantsListUserResponse } = await getRequest(endpoint);
  return data;
};

export const agoraEndSessionPodcastService = async (requestData: {
  session_id: string;
}) => {
  let endpoint =
    ApiName.agoraEndSessionPodcast + "?sessionId=" + requestData.session_id;
  let { data }: { data: ISessionEndResponse } = await postRequest(endpoint, {});
  return data;
};

export const rightsAllowPodcastService = async (requestData: {
  session_id: number | null;
  userId: number | null;
}) => {
  let endpoint =
    ApiName.rightsAllowPodcast +
    "?sessionId=" +
    requestData.session_id +
    "&userId=" +
    requestData.userId;
  let { data }: { data: IRightsAllowResponse } = await postRequest(
    endpoint,
    requestData
  );
  return data;
};

export const rightsRevokePodcastService = async (requestData: {
  session_id: number | null;
  userId: number | null;
}) => {
  let endpoint =
    ApiName.rightsRevokePodcast +
    "?sessionId=" +
    requestData.session_id +
    "&userId=" +
    requestData.userId;
  let { data }: { data: IRightsRevokeResponse } = await postRequest(
    endpoint,
    requestData
  );
  return data;
};

export const rejectRequestPodcastService = async (requestData: {
  session_id: number | null;
  userId: number | null;
}) => {
  let endpoint =
    ApiName.rejectRequestPodcast +
    "?sessionId=" +
    requestData.session_id +
    "&userId=" +
    requestData.userId;
  let { data }: { data: IRejectResponse } = await postRequest(
    endpoint,
    requestData
  );
  return data;
};

export const agoraCheckSessionEndedPodcastService = async (requestData: {
  session_id: string;
}) => {
  let endpoint =
    ApiName.sessionEndedPodcast + "?sessionId=" + requestData.session_id;
  let { data }: { data: ICheckSessionEndResponse } = await getRequest(endpoint);
  return data;
};

export const agoraLiveCommentsPodcastService = async (requestData: {
  session_id: string;
}) => {
  let endpoint =
    ApiName.liveCommentsPodcast + "?sessionId=" + requestData.session_id;
  let { data }: { data: IMessageResponse } = await getRequest(endpoint);
  return data;
};
